import React, { useState } from 'react';
import {
  HomeOutlined,
  UserOutlined,
  SettingOutlined,
  LineChartOutlined,
  PoweroffOutlined,
  ShareAltOutlined,
  SafetyOutlined,
  ContainerOutlined,
  CalculatorOutlined,
  SmileOutlined,
} from '@ant-design/icons';
import TokenService from 'src/services/token';
import { useLocation, useNavigate } from 'react-router-dom';
import { Modal } from 'antd';

type SidebarProps = {
  show: boolean;
};
const Sidebar = ({ show, ...props }: SidebarProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const user = TokenService.getUser();
  const [showConfirmLogout, setShowConfirmLogout] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const handleMouseEnter = () => setIsOpen(true);
  const handleMouseLeave = () => setIsOpen(false);
  const onLogout = () => {
    TokenService.clearLocalStorage();
    navigate('/login');
  };
  const isActive = (path: string) => location.pathname.startsWith(path);

  const linkClasses = (path: string) =>
    `ml-[18px] mr-[18px] flex items-center p-2 rounded-lg group transition relative
     ${isActive(path) ? 'bg-gray-100 text-[#669300] before:content-[""] before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:w-[2.5px] before:h-8 before:bg-green-600 before:rounded-r' : 'text-gray-900 hover:bg-gray-100'}`;

  const iconStyle = (path: string) => ({
    fontSize: 20,
    color: isActive(path) ? '#669300' : undefined,
  });
  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`z-40 hover:w-[220px] transition-all duration-300 fixed top-0 left-0 h-screen w-[72px] shadow bg-white overflow-x-hidden`}
    >
      <a
        href="/"
        className="ml-[18px] mr-[18px] flex items-center mt-[6px] mb-[6px] text-2xl font-semibold text-gray-900"
      >
        <img className="w-8 h-8 mr-[18px]" src="/favicon.png" alt="logo" />
        {isOpen ? <h2 className="transition">Homekit</h2> : null}
      </a>
      <ul className="space-y-2 font-medium">
        <li>
          <a
            href="/"
            className="ml-[18px] mr-[18px] flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 group"
          >
            <HomeOutlined style={{ fontSize: 20 }} />
            {isOpen && <span className="flex-1 ms-3 transition whitespace-nowrap">Trang chủ</span>}
          </a>
        </li>
        <li>
          <a href="/leads" className={linkClasses('/leads')}>
            {/* {isActive('/leads') && (
              <div className="absolute left-0 top-1/2 -translate-y-1/2 w-[2px] h-8 bg-green-600 rounded-r"></div>
            )} */}
            <UserOutlined style={iconStyle('/leads')} />
            {isOpen && <span className="flex-1 ms-3 whitespace-nowrap">Leads</span>}
          </a>
        </li>
        <li>
          <a href="/mentor" className={linkClasses('/mentor')}>
            <SafetyOutlined style={iconStyle('/mentor')} />
            {isOpen && <span className="flex-1 ms-3 whitespace-nowrap">Dò bài</span>}
          </a>
        </li>
        <li>
          <a href="/orders" className={linkClasses('/orders')}>
            <ContainerOutlined style={iconStyle('/orders')} />
            {isOpen && <span className="flex-1 ms-3 whitespace-nowrap">Đơn hàng</span>}
          </a>
        </li>
        <li>
          <a href="/customers" className={linkClasses('/customers')}>
            <SmileOutlined style={iconStyle('/customers')} />
            {isOpen && <span className="flex-1 ms-3 whitespace-nowrap">Khách hàng</span>}
          </a>
        </li>
        <li>
          <a href="/inventory-workers" className={linkClasses('/inventory-workers')}>
            <CalculatorOutlined style={iconStyle('/inventory-workers')} />
            {isOpen && <span className="flex-1 ms-3 whitespace-nowrap">Kho của thợ</span>}
          </a>
        </li>
        {[1, 4].includes(user.role) && (
          <li>
            <a href="/statistics" className={linkClasses('/statistics')}>
              <LineChartOutlined style={iconStyle('/statistics')} />
              {isOpen && <span className="flex-1 ms-3 whitespace-nowrap">Thống kê</span>}
            </a>
          </li>
        )}
        {user.role == 1 && (
          <li>
            <a href="/permissions" className={linkClasses('/permissions')}>
              <ShareAltOutlined style={iconStyle('/permissions')} />
              {isOpen && <span className="flex-1 ms-3 whitespace-nowrap">Phân quyền</span>}
            </a>
          </li>
        )}
        <li>
          <a href="/settings" className={linkClasses('/settings')}>
            <SettingOutlined style={iconStyle('/settings')} />
            {isOpen && <span className="flex-1 ms-3 whitespace-nowrap">Settings</span>}
          </a>
        </li>
      </ul>
      <div className="absolute bottom-0 left-0 w-full mb-[12px]">
        <ul>
          <li>
            <a
              className="ml-[18px] mr-[18px] flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 group"
              onClick={() => setShowConfirmLogout(true)}
            >
              <PoweroffOutlined style={{ fontSize: 20, color: 'red' }} />
              {isOpen && <span className="flex-1 ms-3 transition whitespace-nowrap text-red-500">Đăng xuất</span>}
            </a>
          </li>
        </ul>
      </div>
      <Modal title="Xác nhận" open={showConfirmLogout} onOk={onLogout} onCancel={() => setShowConfirmLogout(false)}>
        <p>Bạn có muốn đăng xuất ?</p>
      </Modal>
    </div>
  );
};

export default Sidebar;
